/**
 * Escaping special chars in a string value.
 *
 * @see {@link http://stackoverflow.com/questions/3446170/escape-string-for-use-in-javascript-regex/6969486#6969486}
 * @param {string} value - The text value to escape
 * @returns {string} The escaped value
 */
function escapeRegExp(value) {
    return value.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&')
}

export { escapeRegExp }
